import { Component } from '@angular/core';
import {
  getDashboardReportsOfferSelect,
  getDashboardReportsOfferSelectLoaded,
  getDashboardReportsSelect,
  getDashboardReportsSelectLoaded,
  getDashboardReportsSumissionSelect,
  getDashboardReportsSumissionSelectLoaded,
} from '@modules/reports/store/referral-reports.selectors';
import { Store } from '@ngrx/store';
import { AppFeatureExtensions } from '@app/app-feature-extensions.config';
import { MojoFeatureExtensionsService } from 'mojo-feature-extensions';

@Component({
  selector: 'mojo-dashboard-bar-charts',
  styleUrls: ['./dashboard-bar-charts.component.scss'],
  templateUrl: './dashboard-bar-charts.component.html',
})
export class DashboardBarChartsComponent {
  dashboardDisplayOffer = AppFeatureExtensions.DASHBOARD_DISPLAY_OFFER;
  isOfferDisplayed = this.featureService.hasFeatureExtension(this.dashboardDisplayOffer);
  selectReportsDashboard$ = this.store.select(getDashboardReportsSelect);
  selectReportsDashboardLoaded$ = this.store.select(getDashboardReportsSelectLoaded);

  selectReportsDashboardSubmission$ = this.store.select(getDashboardReportsSumissionSelect);
  selectReportsDashboardSubmissionLoaded$ = this.store.select(
    getDashboardReportsSumissionSelectLoaded,
  );

  selectReportsDashboardOffer$ = this.store.select(getDashboardReportsOfferSelect);
  selectReportsDashboardOfferLoaded$ = this.store.select(getDashboardReportsOfferSelectLoaded);

  constructor(private store: Store<{}>, private featureService: MojoFeatureExtensionsService) {}
}
